import { render } from "./VTextFieldAsync.vue?vue&type=template&id=18cfcfa0"
import script from "./VTextFieldAsync.vue?vue&type=script&lang=js"
export * from "./VTextFieldAsync.vue?vue&type=script&lang=js"

import exportComponent from "/builds/uf-manage/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__